import React from 'react';
import styled from 'styled-components';
import { Button, ButtonGroup, CircularProgress, Divider, Icon, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';
import { useEntityContext } from '../EntityContext';
import EntityRelationshipListRow from './EntityRelationshipListRow';
const StyledDiv = styled.div `
  .header {
    display: flex;
    align-items: center;
    padding: 12px;
  }
  .action-buttons {
    display: flex;
    margin-left: 8px;
  }
  .saving-status {
    margin-top: 3px;
    margin-left: 12px;
    min-height: 19px;
    display: flex;
    justify-content: center;
    .save-label {
      margin-left: 8px;
    }
  }
`;
const EntityRelationshipList = props => {
    var _a;
    const { entity } = props;
    const { isQueued, isUpdating, trackChanges } = useEntityContext();
    return (React.createElement(StyledDiv, null,
        React.createElement("div", { className: 'header' },
            React.createElement(ButtonGroup, { disabled: !entity.editable, className: 'action-buttons' },
                React.createElement(Button, { onClick: () => trackChanges.undo() },
                    React.createElement(Icon, null, "undo")),
                React.createElement(Button, { onClick: () => trackChanges.redo() },
                    React.createElement(Icon, null, "redo"))),
            React.createElement("div", { className: 'saving-status' }, (isQueued || isUpdating) && (React.createElement(React.Fragment, null,
                React.createElement(CircularProgress, { size: 16 }),
                React.createElement(Typography, { variant: 'caption', className: 'save-label' }, isQueued ? 'Queued...' : 'Saving...'))))),
        React.createElement(Divider, null),
        React.createElement(TableContainer, null,
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, "Relation Name"),
                        React.createElement(TableCell, null, "Relationship Type"),
                        React.createElement(TableCell, null, "Target Entity"),
                        React.createElement(TableCell, null, "Join Column / Inverse Column"),
                        React.createElement(TableCell, null))),
                React.createElement(TableBody, null, (_a = entity.relations) === null || _a === void 0 ? void 0 :
                    _a.map((relation, index) => (React.createElement(EntityRelationshipListRow, { key: `${entity.id || entity.displayName}-${index}`, index: index, entity: entity, relation: relation, disabled: !entity.editable || relation.locked }))),
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: 9 },
                            React.createElement(Button, { color: 'primary', variant: 'outlined', disabled: !entity.editable, startIcon: React.createElement(Icon, null, "add"), onClick: () => {
                                    if (!entity.relations) {
                                        trackChanges.update('relations', []);
                                    }
                                    const relation = {
                                        displayName: '',
                                        propertyName: '',
                                        target: '',
                                        type: 'many-to-one'
                                    };
                                    trackChanges.insert('relations', relation);
                                } }, "Add Relationship"))))))));
};
export default EntityRelationshipList;
//# sourceMappingURL=EntityRelationshipList.js.map